import React from "react";

const Dialog = ({ message, onDialog }) => {
  // if (!show) {
  //   return <></>;
  // }
  return (
    <div
      className="game-dialog"
      style={{
        position: "fixed",
        top: "0",
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "absolute",
          justifyContent: "center",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          background: "white",
          padding: "50px",
        }}
      >
        <p
          style={{
            color: "#111",
            textTransform: "uppercase",
            fontWeight: "400",
          }}
        >
          {message}
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "white",
          }}
        >
          <button
            // onClick={onDialog(true)}
            onClick={() => onDialog(true)}
            style={{
              background: "red",
              color: "white",
              padding: "10px",
              marginRight: "4px",
              border: "none",
              cursor: "pointer",
            }}
          >
            Quit
          </button>
          <button
            onClick={() => onDialog(false)}
            // onClick={onDialog(false)}
            style={{
              background: "green",
              color: "white",
              padding: "10px",
              marginLeft: "4px",
              border: "none",
              cursor: "pointer",
            }}
          >
            Play
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
